var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoPositions(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.75 1.5C6.09 1.5 1.5 6.089 1.5 11.75C1.5 14.52 2.6 17.032 4.38 18.877C5.11 17.185 6.79 16 8.75 16H14.75C16.71 16 18.39 17.185 19.12 18.877C20.9 17.032 22 14.52 22 11.75C22 6.089 17.41 1.5 11.75 1.5ZM17.9 19.95C17.54 18.542 16.27 17.5 14.75 17.5H8.75C7.23 17.5 5.96 18.542 5.6 19.95C7.31 21.237 9.44 22 11.75 22C14.06 22 16.19 21.237 17.9 19.95ZM0 11.75C0 5.261 5.26 0 11.75 0C18.24 0 23.5 5.261 23.5 11.75C23.5 15.414 21.82 18.687 19.2 20.84C17.17 22.502 14.58 23.5 11.75 23.5C8.92 23.5 6.33 22.502 4.3 20.84C1.68 18.687 0 15.414 0 11.75ZM11.75 6.5C9.94 6.5 8.48 7.958 8.48 9.75C8.48 11.542 9.94 13 11.75 13C13.56 13 15.02 11.542 15.02 9.75C15.02 7.958 13.56 6.5 11.75 6.5ZM6.98 9.75C6.98 7.124 9.12 5 11.75 5C14.38 5 16.52 7.124 16.52 9.75C16.52 12.376 14.38 14.5 11.75 14.5C9.12 14.5 6.98 12.376 6.98 9.75Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoPositions);
export default __webpack_public_path__ + "static/media/ico-positions.aea80fdc.svg";
export { ForwardRef as ReactComponent };